export function getSelectedCoordinates (selectedElems) {
  const xCoords = [];
  const yCoords = [];

  let selected;
  let selectedCoord = null;

  if (selectedElems.length > 1) {
    selected = selectedElems[0];

    for (let i = 0; i < selectedElems.length; i++) {
      const elemCoord = INKIVE.Helpers.getSelectedCoordinates(selectedElems[i]);
      xCoords.push(elemCoord.x1, elemCoord.x2, elemCoord.x3, elemCoord.x4);
      yCoords.push(elemCoord.y1, elemCoord.y2, elemCoord.y3, elemCoord.y4);
    }

    const minX = Math.min(...xCoords);
    const minY = Math.min(...yCoords);
    const maxX = Math.max(...xCoords);
    const maxY = Math.max(...yCoords);

    selectedCoord = {
      x1: minX, // top left horizontal
      y1: minY,
      x2: maxX, // top right horizontal
      y2: minY,
      x3: minX, // bottom left horizontal
      y3: maxY,
      x4: maxX, // bottom right horizontal
      y4: maxY,
      x5: (minX + maxX) / 2, // middle horizontal
      y5: (minY + maxY) / 2
    };
  } else if (selectedElems.length === 1) {
    selected = selectedElems[0];
    selectedCoord = INKIVE.Helpers.getSelectedCoordinates(selected);
  }

  return selectedCoord;
}

export function coordinateToBoundingBox (selectedCoord) {
  return {
    x: selectedCoord.x1,
    y: selectedCoord.y1,
    width: selectedCoord.x4 - selectedCoord.x1,
    height: selectedCoord.y4 - selectedCoord.y1
  };
}
